var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Just a random guy who's eager to learn, experiment & improve. Loves development, indie + simulation games & anything which flies 😊. That's all, if you expected more, sorry to disappoint. ")])}
var staticRenderFns = []

export { render, staticRenderFns }